import { useState, useEffect } from 'react';
import { NavBar } from './components/layouts/NavBar';
import { Footer } from './components/layouts/Footer';
import { Projects } from './pages/Projects';
import { ProjectDetail } from './pages/ProjectDetail';
import { Home } from './pages/Home';
import { Contact } from './pages/Contact';
import { Page, NavigateFn } from './utils/interfaces/types';
import { useProjects } from './context/ProjectsContext';

function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const [currentProject, setCurrentProject] = useState<number | null>(null);
  const { projects, loadProjects } = useProjects();
  const [navTheme, setNavTheme] = useState<string | undefined>(undefined);

  const navigate: NavigateFn = (page, projectId = null) => {
    setCurrentPage(page);
    setCurrentProject(projectId);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    if (currentPage === 'project') loadProjects();
  }, [currentPage, loadProjects]);

  useEffect(() => {
    if (currentPage === 'project' && currentProject !== null) {
      const project = projects.find((p) => p.id === currentProject);
      setNavTheme(project?.navTheme);
    } else {
      setNavTheme(undefined);
    }
  }, [currentPage, currentProject, projects]);

  const renderPage = () => {
    if (currentPage === 'home') return <Home navigate={navigate} />;
    if (currentPage === 'projects')
      return <Projects navigate={navigate} projects={projects} />;
    if (currentPage === 'project' && currentProject !== null) {
      const project = projects.find((p) => p.id === currentProject);
      return <ProjectDetail project={project} navigate={navigate} />;
    }
    if (currentPage === 'contact') return <Contact />;
    return <Home navigate={navigate} />;
  };
  return (
    <>
      <NavBar navigate={navigate} currentPage={currentPage} color={navTheme} />
      <main>{renderPage()}</main>
      <Footer />
    </>
  );
}

export default App;
